import React from 'react';
import styled from 'styled-components';
import { useHistory } from "react-router";
import { useDispatch, useSelector } from 'react-redux';

import { Button } from 'components';
import { Bar } from 'features';
import { FaReceipt } from 'react-icons/fa';

import { userContext } from 'context';
import * as actionCreators from 'store/actions';

const Container = styled.div`
    background-color: var(--primary-accent-color);
    border-radius: 5px;
    padding: 0.5rem 1rem;
    margin: 0.5rem 1rem 1rem 1rem;
    box-shadow: var(--box-shadow);
    /* border-top: 1px solid var(--secondary-accent-color); */
`

const Header = styled.div`
    display: flex;
    align-items: center;
    padding: 0.5rem 0;
    margin: 0 0 0.5rem 0;
`

const Icon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 1rem 0 0;
    font-size: 1.5rem;
`

const Title = styled.div`
    font-weight: bold;
`

const buttonStyle = {
    backgroundColor: 'var(--focus-color)',
    width: 'inherit',
    margin: '0.5rem 0',
    padding: '0.5rem'
}

const barStyle = {
    height: '0.3rem',
    margin: '0 0 1rem 0'
}

const UpgradeSection = props => {
    const {

    } = props;
    const history = useHistory();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth.user);
    const created = useSelector((state) => state.auth.created);
    const plan = user['subscription_plan']

    // React.useEffect(() => {
    //     dispatch(actionCreators.getUserCount(user['uid']))
    // }, [])

    const onUpgrade = () => {
        const oldUser = {...user}
        let newUser = user
        newUser['activePageID'] = 'SETTINGS-SUBSCRIPTION'
        newUser['activePageType'] = 'Modules'
        dispatch(actionCreators.updateUser(newUser, oldUser))
        history.push('SETTINGS')
    }

    return (
        <Container>
            <Header>
                <Icon><FaReceipt/></Icon>
                <Title>
                    {plan === userContext.PLANS.BETA ? 'Premium plan (beta)'
                    : plan === userContext.PLANS.PREMIUM ? 'Premium plan' 
                    : 'Personal plan'}
                </Title>
            </Header>
            <Bar label='Tasks' 
                value={`${created || '-'} / ${[userContext.PLANS.PREMIUM, userContext.PLANS.BETA].includes(plan) ? '∞' : '1000'}`} 
                percent={`${[userContext.PLANS.PREMIUM, userContext.PLANS.BETA].includes(plan) ? 100 : created ? Math.round(created/10) : 0}%`} 
                orientation='horizontal' styles={barStyle}/>
            {user['subscription_plan'] === userContext.PLANS.PERSONAL && <Button text='Upgrade plan' styles={buttonStyle} onSelect={onUpgrade}/>}
        </Container>
    )
}

export default UpgradeSection